module.exports = {
	props: {
		item: {
			required: true,
			type: Object
		},  
		index: [String, Number],
		hideDetails: {
			type: Boolean,
			default: false
		},
		removable: {
			type: Boolean,
			default: false
		}
	}
};
